import { styled } from '../../../base';

export const ChatContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    height: '100%',
    width: '100%',
    overflow: 'hidden',
}));

interface MainChatWrapperProps {
    hasResults: boolean;
}

export const MainChatWrapper = styled('div')<MainChatWrapperProps>(
    ({ theme: _theme, hasResults }) => ({
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        transition: 'width 0.5s ease-in-out',
        width: hasResults ? '50%' : '100%',
    })
);

interface ContentDisplayWrapperProps {
    show: boolean;
}

export const ContentDisplayWrapper = styled('div')<ContentDisplayWrapperProps>(
    ({ theme, show }) => ({
        width: show ? '40%' : '0%',
        overflow: 'hidden',
        transition: 'width 0.5s ease-in-out',
        borderLeft: show ? `1px solid ${theme.palette.divider}` : 'none',
        height: '100%',
    })
);
